export const API_URL = (process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : "http://localhost:3000");
